(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".stat-number");

  counters.forEach(counter => {
    const target = parseFloat(counter.getAttribute("data-count"));
    let current = 0;

    function update() {
      current += target / 60;
      if (current < target) {
        counter.innerText = current.toFixed(1);
        requestAnimationFrame(update);
      } else {
        counter.innerText = target;
      }
    }
    update();
  });
});

  } catch(e) { console.error(e); }
})();
})();
